import type { Copyright } from '@smarton-pbx/shared';
import type { ReactNode } from 'react';
import { LanguageSwitch } from '../components/LanguageSwitch';
import { LogoMark } from '../components/LogoMark';

/**
 * Sign-in pages: the tenant's colours and name on one side, the form on the
 * other. On narrow screens only the form, with the name above it. The
 * copyright line names `copyright` (linked, if it has a URL) if given, else the name.
 */
export function AuthLayout({
  name,
  logoUrl,
  copyright,
  children,
}: {
  name: string;
  logoUrl?: string | null;
  copyright?: Copyright | null;
  children: ReactNode;
}) {
  const mark = (
    <>
      {logoUrl ? (
        <LogoMark name={name} logoUrl={logoUrl} />
      ) : (
        <>
          <span className="monogram">{name.trim()[0]?.toUpperCase()}</span>
          <span>{name}</span>
        </>
      )}
    </>
  );
  return (
    <div className="auth">
      <section className="auth-brand">
        <div className="brand-mark" aria-hidden>
          {logoUrl ? <img src={logoUrl} alt="" /> : <span className="monogram">{name.trim()[0]?.toUpperCase()}</span>}
        </div>
        <div className="headline" aria-hidden>
          {name}
        </div>
        <div className="foot">
          © {new Date().getFullYear()}{' '}
          {copyright?.url ? (
            <a href={copyright.url} target="_blank" rel="noopener">
              {copyright.holder}
            </a>
          ) : (
            (copyright?.holder ?? name)
          )}
        </div>
      </section>
      <section className="auth-form">
        <div className="auth-card">
          <div className="mobile-brand">{mark}</div>
          {children}
          <div className="auth-language">
            <LanguageSwitch />
          </div>
        </div>
      </section>
    </div>
  );
}
